module.exports = __webpack_public_path__ + "static/media/28.b51a7719.png";